// this should be the same as apps/bazaar/api/v2/constants.py#PAGE_SIZE
import {
    BZ_PACKAGE_SIZE_DETAIL_DEFAULT_LARGE,
    BZ_PACKAGE_SIZE_DETAIL_DEFAULT_MEDIUM,
    BZ_PACKAGE_SIZE_DETAIL_DEFAULT_SMALL,
    BZ_PACKAGE_SIZE_DETAIL_FOOTWEAR_LARGE,
    BZ_PACKAGE_SIZE_DETAIL_FOOTWEAR_MEDIUM,
    BZ_PACKAGE_SIZE_LARGE_detail,
    BZ_PACKAGE_SIZE_MEDIUM_detail,
    BZ_PACKAGE_SIZE_SMALL_detail,
} from 'mk/autogenerated/translations/constants.9c9275b7dcb5079cb27225617e724f6f'
import { PackageSize } from 'mk2/schemas';

export const ITEMS_PER_PAGE = 40;

export const RECENT_REVIEW_DAYS = 90 * 24 * 60 * 60 * 1000; // 90 days
export const REVIEWS_PER_PAGE = 50;
export const TRANSACTIONS_PER_PAGE = 30;

export enum Viewer {
    ADMIN,
    SELLER,
    BUYER,
}

// this should be the same as apps/bazaar/api/v2/constants.py#CATEGORIES_WITH_ORDER
export const CATEGORIES_WITH_ORDER = [
    'footwear',
];

// 1=small, 2=medium, 3=large ... see selectors/schemas.ts
export const CATEGORIES_AND_SIZES = {
    'default': {
        // 1 : BZ_PACKAGE_SIZE_DETAIL_DEFAULT_SMALL,
        [PackageSize.X2]: BZ_PACKAGE_SIZE_DETAIL_DEFAULT_MEDIUM,
        [PackageSize.X3]: BZ_PACKAGE_SIZE_DETAIL_DEFAULT_LARGE,
    },
    'footwear': {
        [PackageSize.X2]: BZ_PACKAGE_SIZE_DETAIL_FOOTWEAR_MEDIUM,
        [PackageSize.X3]: BZ_PACKAGE_SIZE_DETAIL_FOOTWEAR_LARGE,
    },
};

export const SIZES = {
    // 1 : BZ_PACKAGE_SIZE_SMALL_detail,
    [PackageSize.X2]: BZ_PACKAGE_SIZE_MEDIUM_detail,
    [PackageSize.X3]: BZ_PACKAGE_SIZE_LARGE_detail,
};
